var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSetting(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "icon",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#db343b",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14 14h3a1 1 0 0 1 0 2h-3v1a1 1 0 0 1-2 0v-4a1 1 0 0 1 2 0v1zM5 8V7a1 1 0 1 1 2 0v4a1 1 0 0 1-2 0v-1H1a1 1 0 1 1 0-2h4zm7-6h5a1 1 0 0 1 0 2h-5v1a1 1 0 0 1-2 0V1a1 1 0 0 1 2 0v1zM7.111 4H.89C.398 4 0 3.552 0 3s.398-1 .889-1H7.11C7.602 2 8 2.448 8 3s-.398 1-.889 1zm9.989 6H9.9c-.497 0-.9-.448-.9-1s.403-1 .9-1h7.2c.497 0 .9.448.9 1s-.403 1-.9 1zm-8.01 6H.91C.406 16 0 15.552 0 15s.407-1 .91-1h8.18c.503 0 .91.448.91 1s-.407 1-.91 1z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSetting);
export default __webpack_public_path__ + "static/media/setting.b459bf3e34cf3b36cd6e9c7ba02fd0e6.svg";
export { ForwardRef as ReactComponent };